import { memo, useContext, useState } from 'react';
import { useTranslate } from '@tolgee/react';
import { FilterBarValueContext } from './context';
import { Input, Select, Tag } from 'antd';
import { css } from '@emotion/css';
import { getStoreCount, StoreScopes } from 'components/StoreScopes';

const FilterBar = memo(() => {
  return (
    <div className="flex h-full items-center">
      <div className="mr-[16px] min-w-[160px]">
        <StoreSelect />
      </div>
      <div className="max-w-[312px] mr-[16px]">
        <KeywordSelect />
      </div>
      <div className="max-w-[238px]">
        <NameFilter />
      </div>
    </div>
  );
});

const StoreSelect = memo(() => {
  const { t } = useTranslate();
  const [visible, setVisible] = useState(false);
  const { storeScopes, setStoreScopes } = useContext(FilterBarValueContext);
  return (
    <Select
      mode="multiple"
      showSearch={false}
      placeholder={t('remind.选择店铺')}
      value={storeScopes?.length ? ['placeholder'] : []}
      allowClear
      onClear={() => {
        setStoreScopes([]);
      }}
      tagRender={() => (
        <Tag>
          {t('department.已选x店铺', {
            x: getStoreCount(storeScopes || []),
          })}
        </Tag>
      )}
      open={visible}
      onDropdownVisibleChange={setVisible}
      placement="bottomLeft"
      dropdownRender={(_menu) =>
        visible ? (
          <StoreScopes
            allowEmpty
            supportWa={false}
            className={css`
              max-height: 95vh;
              overflow-y: auto;
            `}
            value={storeScopes}
            onCancel={() => setVisible(false)}
            showFooterTips={false}
            onChange={(storeScopes) => {
              setStoreScopes(storeScopes);
            }}
          />
        ) : (
          <></>
        )
      }
      className={css`
        width: 160px;
      `}
      dropdownClassName={dropdownClassName}
    />
  );
});

const dropdownClassName = css`
  width: 950px !important;
  overflow-y: auto;
  padding-top: 0;
  padding-bottom: 0;
  color: rgba(0, 0, 0, 0.85);
`;

type KeywordType = 2 | 3 | 4;

const KeywordSelect = memo(() => {
  const { t } = useTranslate();
  const { keywordType, setKeyword, setKeywordType } = useContext(FilterBarValueContext);
  const keywordTypeLabelMap: Record<KeywordType, string> = {
    2: t('sider.商品ID'),
    3: t('aide.主商品货号'),
    4: t('sider.SKU货号'),
  };
  return (
    <Input.Group
      compact
      className={css`
        flex: 1 0 259px;
        display: flex !important;
      `}
    >
      <Select
        value={keywordType}
        onChange={(value) => setKeywordType(value)}
        dropdownMatchSelectWidth={false}
        options={Object.entries(keywordTypeLabelMap).map(([value, label]) => {
          return {
            value: parseInt(value, 10),
            label,
          };
        })}
      />
      <Input.Search
        allowClear
        placeholder={t('trade.请输入')}
        onPressEnter={(e: any) => {
          setKeyword(e?.target?.value);
        }}
        onSearch={(value) => {
          setKeyword(value);
        }}
      />
    </Input.Group>
  );
});

const NameFilter = memo(() => {
  const { setName } = useContext(FilterBarValueContext);
  const { t } = useTranslate();
  return (
    <Input.Search
      onSearch={(value) => {
        setName(value);
      }}
      placeholder={t('department.请输入x', { x: t('sider.商品名称') })}
    />
  );
});

export default FilterBar;
